import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { PieChart } from "react-minimal-pie-chart";
import ScoreResult from "./components/ScoreResult";
import ScoreDescription from "./components/ScoreDescription";
import ScoreDescriptionMore from "./components/ScoreDescriptionMore";
import ReactTooltip from "react-tooltip";
import dataEn from "./data/data.json";
import answersEn from "./data/answers.json";
import dataCz from "./data/dataCz.json";
import answersCz from "./data/answersCz.json";
import dataSk from "./data/dataSk.json";
import answersSk from "./data/answersSk.json";
import dataHu from "./data/dataHu.json";
import answersHu from "./data/answersHu.json";
import "./App.css";

const scoreData = [
  {
    title: "Flexibility",
    value: 1,
    color: "#00000060",
    id: undefined,
    info: undefined,
    moreInfo: undefined,
  },
  {
    title: "Engagement and well being",
    value: 2,
    color: "#00000010",
    id: undefined,
    info: undefined,
    moreInfo: undefined,
  },
  {
    title: "Great people and atmosphere",
    value: 3,
    color: "#00000020",
    id: undefined,
    info: undefined,
    moreInfo: undefined,
  },
  {
    title: "Helping others",
    value: 4,
    color: "#00000030",
    id: undefined,
    info: undefined,
    moreInfo: undefined,
  },
  {
    title: "Development and learning",
    value: 5,
    color: "#00000040",
    id: undefined,
    info: undefined,
    moreInfo: undefined,
  },
  {
    title: "You're respected for who you are",
    value: 6,
    color: "#00000050",
    id: undefined,
    info: undefined,
    moreInfo: undefined,
  },
];

let data;
let data2;

function Quiz() {
  const { t, i18n } = useTranslation();
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [name, setName] = useState("Peter");
  const [isMan, setIsMan] = useState(true);
  const [isWoman, setIsWoman] = useState(false);
  const [quiz, setQuiz] = useState([]);
  const [error, setError] = useState("");
  const [answers, setAnswers] = useState({});
  const [score, setScore] = useState([]);
  const [scoreInfo, setScoreInfo] = useState(scoreData);
  const [selected, setSelected] = useState(0);
  const [hovered, setHovered] = useState(undefined);
  const [scoreIndex, setScoreIndex] = useState(0);

  if (i18n.language && i18n.language === "hu") {
    data = dataHu;
    data2 = answersHu;
  } else if (i18n.language && i18n.language === "sk-SK") {
    data = dataSk;
    data2 = answersSk;
  } else if (
    i18n.language &&
    (i18n.language === "cs" || i18n.language === "cz")
  ) {
    data = dataCz;
    data2 = answersCz;
  } else {
    data = dataEn;
    data2 = answersEn;
  }

  const nextQuestion = () => {
    if (currentQuestion > 0 && !answers[currentQuestion]) {
      setError(
        t(
          "Choose an answer before continuing",
          "Choose an answer before continuing"
        )
      );
    } else if (currentQuestion === quiz.length) {
      calculatePoints();
      setCurrentQuestion(currentQuestion + 1);
    } else {
      setCurrentQuestion(currentQuestion + 1);
    }
  };

  const calculatePoints = () => {
    let points = [];
    for (let [key, value] of Object.entries(answers)) {
      const pointName = Object.keys(value.points)[0];
      const pointValue = parseInt(Object.values(value.points));
      if (!points[pointName]) {
        points[pointName] = 0;
      }
      points[pointName] += pointValue;
    }
    setScore(points);
  };

  const calculateScore = () => {
    // console.log(data2)
    const tmpScore = [];
    let i = 0;
    let biggestScore = 0;
    for (let [key, value] of Object.entries(score)) {
      // console.log("KEY");
      // console.log(key);
      if (value > biggestScore) {
        biggestScore = value;
        setSelected(i);
        setScoreIndex(i);
      }

      const color = i === 0 ? "#00000010" : `#000000${i + 1}0`;
      const info = data2.filter((el) => {
        return el.name === key;
      });
      // console.log("Info" + i);
      // console.log(info);
      if (info) {
        tmpScore.push({
          id: i,
          title: info[0]["area"],
          value: parseInt(value),
          color: color,
          info: info[0]["info"],
          moreInfo: info[0]["moreInfo"],
        });
      }
      i++;
    }
    setScoreInfo(tmpScore);
  };

  const handleClick = (answer) => {
    setError("");
    setAnswers({ ...answers, [currentQuestion]: answer });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    nextQuestion();
  };

  const handleCheckbox = (event) => {
    if (event.target.value === "man") {
      window.localStorage.setItem("gender", "man");
      setIsMan(true);
      setIsWoman(false);
    } else {
      window.localStorage.setItem("gender", "woman");
      setIsMan(false);
      setIsWoman(true);
    }
  };

  const handleName = (event) => {
    event.preventDefault();
    if (event.target.value) {
      window.localStorage.setItem("name", event.target.value);
      setName(event.target.value);
    } else {
      window.localStorage.setItem("name", "Peter");
      setName("Peter");
    }
  };

  useEffect(() => {
    setQuiz(data);
    const g = window.localStorage.getItem("gender");
    if (g === "woman") {
      setIsMan(false);
      setIsWoman(true);
    } else {
      window.localStorage.setItem("gender", "man");
      setIsMan(true);
      setIsWoman(false);
    }
  }, []);

  useEffect(() => {
    const n = window.localStorage.getItem("name");
    if (n) {
      setName(n);
    }
  }, [name]);

  useEffect(() => {
    calculateScore();
  }, [score]);

  // useEffect(() => {
  //   console.log(scoreInfo);
  // }, [scoreInfo]);

  if (currentQuestion === null) {
    return (
      <div className="App">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6 d-flex tc-hp-slide" id="quizpage">
              <div className="d-flex justify-content-center text-left flex-column mx-lg-auto tc-hp-slide-inner w-100 align-items-stretch">
                <form onSubmit={handleSubmit}>
                  <h1 className="mb-5">
                    {t(
                      "Are we suitable",
                      "Are we suitable for you? Discover it"
                    )}
                    <span>.</span>
                    {/* Are we suitable for you? Discover it<span>.</span> */}
                  </h1>
                  <p className="mb-5">
                    {t(
                      "Find out what",
                      "Find out what is important for your satisfaction at work, discover if we're a good fit for you and what you can expect from working at Tesco."
                    )}
                  </p>
                  <p>
                    {t(
                      "Don't worry",
                      "Don't worry, it will take only 5 minutes."
                    )}
                  </p>
                  <div className="row mb-2">
                    <div className="col-sm-12">
                      <input
                        className="form-control shadow-sm px-3"
                        onChange={handleName}
                      />
                    </div>
                  </div>
                  <div className="row no-gutters">
                    <div className="col-sm-6 mb-2">
                      <div className=" form-control border shadow-sm w-100 mb-1 d-block rounded">
                        <div className="form-check form-check-inline w-50">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="man"
                            value="man"
                            checked={isMan}
                            onChange={handleCheckbox}
                          />
                          <label className="form-check-label" htmlFor="man">
                            {t("Man", "Man")}
                          </label>
                        </div>
                        <div className="form-check form-check-inline w-25">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="woman"
                            value="woman"
                            checked={isWoman}
                            onChange={handleCheckbox}
                          />
                          <label className="form-check-label" htmlFor="woman">
                            {t("Woman", "Woman")}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6 mb-2 pl-2">
                      <button
                        type="submit"
                        className="btn btn-block btn-danger"
                        // onClick={nextQuestion}
                      >
                        {t("OK", "OK")}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div
              className={`col-lg-6 d-flex align-items-center justify-content-center quiz-bg ${
                isWoman ? "woman" : ""
              }`}
            >
              <h1 className="gh">
                {name}
                <span>.</span>
              </h1>
            </div>
          </div>
        </div>
      </div>
    );
  } else if (currentQuestion === data.length + 1) {
    const shiftSize = 6;
    const data = scoreInfo.map((entry, i) => {
      if (hovered === i) {
        return {
          ...entry,
          color: "#00539F",
        };
      }
      if (selected === i) {
        return {
          ...entry,
          color: "#00539F",
        };
      }
      return entry;
    });

    const makeTooltipContent = (entry) => {
      return `${entry.title}`;
    };

    return (
      <div className="App">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6 d-flex tc-hp-slide" id="quizpage">
              <div className="d-flex justify-content-center text-left flex-column mx-lg-auto tc-hp-slide-inner w-100 align-items-stretch">
                <h2 className="mb-5">
                  {t(
                    "Thank you for filling",
                    "Thank you for filling the test. What do you value the most at work based on the results?"
                  )}
                </h2>
                <div className="row d-flex">
                  <div className="col-lg-6 align-items-strech">
                    <div data-tip="" data-for="chart">
                      <PieChart
                        data={data}
                        // style={{ height: "285px", width: "285px" }}
                        animate
                        onClick={(event, index) => {
                          // console.log(event.target.label)
                          // console.log('CLICK', { event, index });
                          setSelected(index === selected ? undefined : index);
                          setScoreIndex(index);
                        }}
                        radius={PieChart.defaultProps.radius - shiftSize}
                        segmentsShift={(index) => (index === selected ? 6 : 0)}
                        onMouseOver={(_, index) => {
                          setHovered(index);
                        }}
                        onMouseOut={() => {
                          setHovered(undefined);
                        }}
                      />
                      <ReactTooltip
                        id="chart"
                        textColor="#000"
                        backgroundColor="#fff"
                        getContent={() =>
                          typeof hovered === "number"
                            ? makeTooltipContent(data[hovered])
                            : null
                        }
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 align-items-strech align-self-center">
                    <ScoreResult data={scoreInfo} index={scoreIndex} />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 align-items-strech align-items-center quiz-dark">
              <div className="pt-4 pb-5 px-1 p-sm-5  d-flex flex-column align-items-strech justify-content-center h-100">
                <h2 className="gh">
                  {name}
                  <span>.</span>
                </h2>
                <div
                  className="mb-4"
                  // dangerouslySetInnerHTML={{ __html: data2[scoreIndex].info }}
                >
                  <ScoreDescription data={scoreInfo} index={scoreIndex} />
                </div>
                <h3 className="mb-4">
                  {t(
                    "We are sure that",
                    "We are sure that you will find at Tesco everything what you appreciate the most at work. Check out our jobs:"
                  )}
                </h3>
                <nav className="d-flex w-100 flex-column flex-lg-row tesco-buttons">
                  <a
                    href="/career-store/"
                    className="btn d-flex flex-grow-1 justify-content-center btn-danger btn-tesco-red ic-01"
                  >
                    {t("Store", "Store")}
                  </a>
                  <a
                    href="/career-office/"
                    className="btn d-flex flex-grow-1 justify-content-center btn-danger btn-tesco-red ic-02"
                  >
                    {t("Office", "Office")}
                  </a>
                  <a
                    href="/career-distribution/"
                    className="btn d-flex flex-grow-1 justify-content-center btn-danger btn-tesco-red ic-03"
                  >
                    {t("Distribution", "Distribution")}
                  </a>
                </nav>
              </div>
            </div>
          </div>
          <ScoreDescriptionMore data={scoreInfo} index={scoreIndex} />
        </div>
      </div>
    );
  } else {
    const answersList = quiz[currentQuestion - 1].answers.map((answer) => {
      return (
        <div
          key={answer.aid}
          className="p-2 border shadow-sm w-100 mb-1 d-block rounded bg-white"
          onClick={() => handleClick(answer)}
        >
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              value=""
              onChange={() => handleClick(answer)}
              checked={
                answers[currentQuestion] &&
                answers[currentQuestion].aid === answer.aid
                  ? "checked"
                  : 0
              }
              id={`answer${answer.aid}`}
            />
            <label className="form-check-label" htmlFor={`answer${answer.aid}`}>
              {answer.answer}
            </label>
          </div>
        </div>
      );
    });

    return (
      <div className="App">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6 d-flex tc-hp-slide" id="quizpage">
              <div className="d-flex justify-content-center text-left flex-column mx-lg-auto tc-hp-slide-inner w-100 align-items-stretch">
                <h1>
                  <strong>
                    {currentQuestion}/{quiz.length}
                  </strong>
                </h1>
                <p>
                  <strong>{quiz[currentQuestion - 1].question}</strong>
                </p>
                {error && <p className="text-danger">{error}</p>}
                <div className="mb-3">{answersList}</div>
                <div className="row mb-3 d-flex">
                  <div className="col-3 align-items-strech">
                    <button className="btn btn-danger" onClick={nextQuestion}>
                      {t("Next", "Next")}
                    </button>
                  </div>
                  <div className="col-9 text-center text-lg-right align-items-strech align-self-center">
                    {t("Skip the test and see", "Skip the test and see")}{" "}
                    <a href="/careers">{t("all positions", "all positions")}</a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 d-flex align-items-stretch justify-content-stretch quiz-dark">
              <div className="h-100 w-100">
                <div className="h-50 pt-4 pb-5 px-1 p-sm-5">
                  <div
                    className={`d-flex align-items-center justify-content-left h-100 w-100`}
                  >
                    <div>
                      <h2 className="gh">
                        {name}
                        <span>.</span>
                      </h2>
                      <p>
                        {answers[currentQuestion] &&
                          answers[currentQuestion].explanation}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className={`h-50 quiz-bg-small  ${isWoman ? "woman" : ""}`}
                >
                  <div
                    className={`d-flex align-items-center justify-content-center h-100 w-100`}
                  >
                    <h2 className="gh">
                      {name}
                      <span>.</span>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Quiz;
